export default __webpack_public_path__ + "static/media/mailBlack.56058da1.svg";